import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import LCADashboard from "./components/LCADashboard";
import ParallaxLanding from "./components/ParallaxLanding";
import DocumentationPage from "./components/DocumentationPage";
import { Toaster } from "./components/ui/toaster";
import LCAToolPage from "./components/LCAToolPage";

import DeepDiveLanding from "./components/DeepDiveLanding";

import ScrollToTop from "./services/ScrollToTop";
import { WallBuildupsProvider } from "./components/lca/LibraryPanel";

function App() {
  return (
    <div className="App">
      <WallBuildupsProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<DeepDiveLanding />} />
            <Route path="/classic" element={<ParallaxLanding />} />
            <Route path="/start" element={<LCADashboard />} />
            <Route path="/dashboard" element={<LCADashboard />} />
            <Route path="/lca" element={<LCADashboard />} />
            <Route path="/wholebuildinglca" element={<LCAToolPage />} />
            <Route path="/dashboard/:tab" element={<LCADashboard />} />
            <Route path="/app" element={<Navigate to="/start" replace />} />
            <Route path="/dashboard/lcatypes" element={<Navigate to="/lca" replace />} />
            <Route path="/template" element={<DocumentationPage />} />
          </Routes>
          <Toaster />
          <Analytics />
        </BrowserRouter>
      </WallBuildupsProvider>
    </div>
  );
}

export default App;
